import { createIcon } from '../createIcon.tsx';

export const SnowflakeIcon = createIcon(
	'SnowflakeIcon',
	<>
		<line x1="2" y1="12" x2="22" y2="12" />
		<line x1="12" y1="2" x2="12" y2="22" />
		<line x1="20" y1="4" x2="4" y2="20" />
		<line x1="20" y1="20" x2="4" y2="4" />
	</>,
);
